export const bankOptions = [
  {
    label: '001-Banco do Brasil S.A.',
    value: '001-Banco do Brasil S.A.',
  },
  {
    label: '003-Banco da Amazônia S.A.',
    value: '003-Banco da Amazônia S.A.',
  },
  {
    label: '004-Banco do Nordeste do Brasil S.A.',
    value: '004-Banco do Nordeste do Brasil S.A.',
  },
  {
    label: '007-Banco Nacional de Desenvolvimento Econômico e Social BNDES',
    value: '007-Banco Nacional de Desenvolvimento Econômico e Social BNDES',
  },
  {
    label: '010-Credicoamo Crédito Rural Cooperativa',
    value: '010-Credicoamo Crédito Rural Cooperativa',
  },
  {
    label: '011-Credit Suisse Hedging-Griffo Corretora de Valores S.A.',
    value: '011-Credit Suisse Hedging-Griffo Corretora de Valores S.A.',
  },
  {
    label: '012-Banco Inbursa S.A.',
    value: '012-Banco Inbursa S.A.',
  },
  {
    label: '014-Natixis Brasil S.A. Banco Múltiplo',
    value: '014-Natixis Brasil S.A. Banco Múltiplo',
  },
  {
    label:
      '015-UBS Brasil Corretora de Câmbio, Títulos e Valores Mobiliários S.A.',
    value:
      '015-UBS Brasil Corretora de Câmbio, Títulos e Valores Mobiliários S.A.',
  },
  {
    label:
      '016-Coop de Créd. Mútuo dos Despachantes de Trânsito de SC e Rio Grande do Sul',
    value:
      '016-Coop de Créd. Mútuo dos Despachantes de Trânsito de SC e Rio Grande do Sul',
  },
  {
    label: '017-BNY Mellon Banco S.A.',
    value: '017-BNY Mellon Banco S.A.',
  },
  {
    label: '018-Banco Tricury S.A.',
    value: '018-Banco Tricury S.A.',
  },
  {
    label: '021-Banestes S.A. Banco do Estado do Espírito Santo',
    value: '021-Banestes S.A. Banco do Estado do Espírito Santo',
  },
  {
    label: '024-Banco Bandepe S.A.',
    value: '024-Banco Bandepe S.A.',
  },
  {
    label: '025-Banco Alfa S.A.',
    value: '025-Banco Alfa S.A.',
  },
  {
    label: '029-Banco Itaú Consignado S.A.',
    value: '029-Banco Itaú Consignado S.A.',
  },
  {
    label: '033-Banco Santander (Brasil) S. A.',
    value: '033-Banco Santander (Brasil) S. A.',
  },
  {
    label: '036-Banco Bradesco BBI S.A.',
    value: '036-Banco Bradesco BBI S.A.',
  },
  {
    label: '037-Banco do Estado do Pará S.A.',
    value: '037-Banco do Estado do Pará S.A.',
  },
  {
    label: '040-Banco Cargill S.A.',
    value: '040-Banco Cargill S.A.',
  },
  {
    label: '041-Banco do Estado do Rio Grande do Sul S.A.',
    value: '041-Banco do Estado do Rio Grande do Sul S.A.',
  },
  {
    label: '047-Banco do Estado de Sergipe S.A.',
    value: '047-Banco do Estado de Sergipe S.A.',
  },
  {
    label: '060-Confidence Corretora de Câmbio S.A.',
    value: '060-Confidence Corretora de Câmbio S.A.',
  },
  {
    label: '062-Hipercard Banco Múltiplo S.A.',
    value: '062-Hipercard Banco Múltiplo S.A.',
  },
  {
    label: '063-Banco Bradescard S.A.',
    value: '063-Banco Bradescard S.A.',
  },
  {
    label: '064-Goldman Sachs do Brasil  Banco Múltiplo S. A.',
    value: '064-Goldman Sachs do Brasil  Banco Múltiplo S. A.',
  },
  {
    label: '065-Banco AndBank (Brasil) S.A.',
    value: '065-Banco AndBank (Brasil) S.A.',
  },
  {
    label: '066-Banco Morgan Stanley S. A.',
    value: '066-Banco Morgan Stanley S. A.',
  },
  {
    label: '069-Banco Crefisa S.A.',
    value: '069-Banco Crefisa S.A.',
  },
  {
    label: '070-Banco de Brasília S.A.',
    value: '070-Banco de Brasília S.A.',
  },
  {
    label: '074-Banco J. Safra S.A.',
    value: '074-Banco J. Safra S.A.',
  },
  {
    label: '075-Banco ABN Amro S.A.',
    value: '075-Banco ABN Amro S.A.',
  },
  {
    label: '076-Banco KDB do Brasil S.A.',
    value: '076-Banco KDB do Brasil S.A.',
  },
  {
    label: '077-Banco Inter S.A.',
    value: '077-Banco Inter S.A.',
  },
  {
    label: '078-Haitong Banco de Investimento do Brasil S.A.',
    value: '078-Haitong Banco de Investimento do Brasil S.A.',
  },
  {
    label: '079-Banco Original do Agronegócio S.A.',
    value: '079-Banco Original do Agronegócio S.A.',
  },
  {
    label: '080-BT Corretora de Câmbio Ltda.',
    value: '080-BT Corretora de Câmbio Ltda.',
  },
  {
    label: '081-BBN Banco Brasileiro de Negocios S.A.',
    value: '081-BBN Banco Brasileiro de Negocios S.A.',
  },
  {
    label: '082-Banco Topazio S.A.',
    value: '082-Banco Topazio S.A.',
  },
  {
    label: '083-Banco da China Brasil S.A.',
    value: '083-Banco da China Brasil S.A.',
  },
  {
    label: '084-Uniprime Norte do Paraná - Cooperativa de Crédito Ltda.',
    value: '084-Uniprime Norte do Paraná - Cooperativa de Crédito Ltda.',
  },
  {
    label: '085-Cooperativa Central de Crédito Urbano - Cecred',
    value: '085-Cooperativa Central de Crédito Urbano - Cecred',
  },
  {
    label: '089-Cooperativa de Crédito Rural da Região da Mogiana',
    value: '089-Cooperativa de Crédito Rural da Região da Mogiana',
  },
  {
    label:
      '091-Central de Cooperativas de Economia e Crédito Mútuo do Est RS - Unicred',
    value:
      '091-Central de Cooperativas de Economia e Crédito Mútuo do Est RS - Unicred',
  },
  {
    label: '092-BRK S.A. Crédito, Financiamento e Investimento',
    value: '092-BRK S.A. Crédito, Financiamento e Investimento',
  },
  {
    label:
      '093-Pólocred Sociedade de Crédito ao Microempreendedor e à Empresa de Pequeno Porte',
    value:
      '093-Pólocred Sociedade de Crédito ao Microempreendedor e à Empresa de Pequeno Porte',
  },
  {
    label: '094-Banco Finaxis S.A.',
    value: '094-Banco Finaxis S.A.',
  },
  {
    label: '095-Banco Confidence de Câmbio S.A.',
    value: '095-Banco Confidence de Câmbio S.A.',
  },
  {
    label: '096-Banco BMFBovespa de Serviços de Liquidação e Custódia S/A',
    value: '096-Banco BMFBovespa de Serviços de Liquidação e Custódia S/A',
  },
  {
    label:
      '097-Cooperativa Central de Crédito Noroeste Brasileiro Ltda - CentralCredi',
    value:
      '097-Cooperativa Central de Crédito Noroeste Brasileiro Ltda - CentralCredi',
  },
  {
    label: '098-Credialiança Cooperativa de Crédito Rural',
    value: '098-Credialiança Cooperativa de Crédito Rural',
  },
  {
    label:
      '099-Uniprime Central – Central Interestadual de Cooperativas de Crédito Ltda.',
    value:
      '099-Uniprime Central – Central Interestadual de Cooperativas de Crédito Ltda.',
  },
  {
    label: '100-Planner Corretora de Valores S.A.',
    value: '100-Planner Corretora de Valores S.A.',
  },
  {
    label:
      '101-Renascença Distribuidora de Títulos e Valores Mobiliários Ltda.',
    value:
      '101-Renascença Distribuidora de Títulos e Valores Mobiliários Ltda.',
  },
  {
    label:
      '102-XP Investimentos Corretora de Câmbio Títulos e Valores Mobiliários S.A.',
    value:
      '102-XP Investimentos Corretora de Câmbio Títulos e Valores Mobiliários S.A.',
  },
  {
    label: '104-Caixa Econômica Federal',
    value: '104-Caixa Econômica Federal',
  },
  {
    label: '105-Lecca Crédito, Financiamento e Investimento S/A',
    value: '105-Lecca Crédito, Financiamento e Investimento S/A',
  },
  {
    label: '107-Banco Bocom BBM S.A.',
    value: '107-Banco Bocom BBM S.A.',
  },
  {
    label: '108-PortoCred S.A. Crédito, Financiamento e Investimento',
    value: '108-PortoCred S.A. Crédito, Financiamento e Investimento',
  },
  {
    label:
      '111-Oliveira Trust Distribuidora de Títulos e Valores Mobiliários S.A.',
    value:
      '111-Oliveira Trust Distribuidora de Títulos e Valores Mobiliários S.A.',
  },
  {
    label: '113-Magliano S.A. Corretora de Cambio e Valores Mobiliarios',
    value: '113-Magliano S.A. Corretora de Cambio e Valores Mobiliarios',
  },
  {
    label:
      '114-Central Cooperativa de Crédito no Estado do Espírito Santo - CECOOP',
    value:
      '114-Central Cooperativa de Crédito no Estado do Espírito Santo - CECOOP',
  },
  {
    label: '117-Advanced Corretora de Câmbio Ltda.',
    value: '117-Advanced Corretora de Câmbio Ltda.',
  },
  {
    label: '118-Standard Chartered Bank (Brasil) S.A. Banco de Investimento',
    value: '118-Standard Chartered Bank (Brasil) S.A. Banco de Investimento',
  },
  {
    label: '119-Banco Western Union do Brasil S.A.',
    value: '119-Banco Western Union do Brasil S.A.',
  },
  {
    label: '120-Banco Rodobens SA',
    value: '120-Banco Rodobens SA',
  },
  {
    label: '121-Banco Agibank S.A.',
    value: '121-Banco Agibank S.A.',
  },
  {
    label: '122-Banco Bradesco BERJ S.A.',
    value: '122-Banco Bradesco BERJ S.A.',
  },
  {
    label: '124-Banco Woori Bank do Brasil S.A.',
    value: '124-Banco Woori Bank do Brasil S.A.',
  },
  {
    label: '125-Brasil Plural S.A. Banco Múltiplo',
    value: '125-Brasil Plural S.A. Banco Múltiplo',
  },
  {
    label: '126-BR Partners Banco de Investimento S.A.',
    value: '126-BR Partners Banco de Investimento S.A.',
  },
  {
    label: '127-Codepe Corretora de Valores e Câmbio S.A.',
    value: '127-Codepe Corretora de Valores e Câmbio S.A.',
  },
  {
    label: '128-MS Bank S.A. Banco de Câmbio',
    value: '128-MS Bank S.A. Banco de Câmbio',
  },
  {
    label: '129-UBS Brasil Banco de Investimento S.A.',
    value: '129-UBS Brasil Banco de Investimento S.A.',
  },
  {
    label:
      '130-Caruana S.A. Sociedade de Crédito, Financiamento e Investimento',
    value:
      '130-Caruana S.A. Sociedade de Crédito, Financiamento e Investimento',
  },
  {
    label: '131-Tullett Prebon Brasil Corretora de Valores e Câmbio Ltda.',
    value: '131-Tullett Prebon Brasil Corretora de Valores e Câmbio Ltda.',
  },
  {
    label: '132-ICBC do Brasil Banco Múltiplo S.A.',
    value: '132-ICBC do Brasil Banco Múltiplo S.A.',
  },
  {
    label:
      '133-Confederação Nacional das Cooperativas Centrais de Crédito e Economia Familiar e',
    value:
      '133-Confederação Nacional das Cooperativas Centrais de Crédito e Economia Familiar e',
  },
  {
    label:
      '134-BGC Liquidez Distribuidora de Títulos e Valores Mobiliários Ltda.',
    value:
      '134-BGC Liquidez Distribuidora de Títulos e Valores Mobiliários Ltda.',
  },
  {
    label:
      '135-Gradual Corretora de Câmbio, Títulos e Valores Mobiliários S.A.',
    value:
      '135-Gradual Corretora de Câmbio, Títulos e Valores Mobiliários S.A.',
  },
  {
    label:
      '136-Confederação Nacional das Cooperativas Centrais Unicred Ltda – Unicred do Brasil',
    value:
      '136-Confederação Nacional das Cooperativas Centrais Unicred Ltda – Unicred do Brasil',
  },
  {
    label: '137-Multimoney Corretora de Câmbio Ltda',
    value: '137-Multimoney Corretora de Câmbio Ltda',
  },
  {
    label: '138-Get Money Corretora de Câmbio S.A.',
    value: '138-Get Money Corretora de Câmbio S.A.',
  },
  {
    label: '139-Intesa Sanpaolo Brasil S.A. - Banco Múltiplo',
    value: '139-Intesa Sanpaolo Brasil S.A. - Banco Múltiplo',
  },
  {
    label: '140-Easynvest - Título Corretora de Valores SA',
    value: '140-Easynvest - Título Corretora de Valores SA',
  },
  {
    label: '142-Broker Brasil Corretora de Câmbio Ltda.',
    value: '142-Broker Brasil Corretora de Câmbio Ltda.',
  },
  {
    label: '143-Treviso Corretora de Câmbio S.A.',
    value: '143-Treviso Corretora de Câmbio S.A.',
  },
  {
    label: '144-Bexs Banco de Câmbio S.A.',
    value: '144-Bexs Banco de Câmbio S.A.',
  },
  {
    label: '145-Levycam - Corretora de Câmbio e Valores Ltda.',
    value: '145-Levycam - Corretora de Câmbio e Valores Ltda.',
  },
  {
    label: '146-Guitta Corretora de Câmbio Ltda.',
    value: '146-Guitta Corretora de Câmbio Ltda.',
  },
  {
    label: '149-Facta Financeira S.A. - Crédito Financiamento e Investimento',
    value: '149-Facta Financeira S.A. - Crédito Financiamento e Investimento',
  },
  {
    label:
      '157-ICAP do Brasil Corretora de Títulos e Valores Mobiliários Ltda.',
    value:
      '157-ICAP do Brasil Corretora de Títulos e Valores Mobiliários Ltda.',
  },
  {
    label: '159-Casa do Crédito S.A. Sociedade de Crédito ao Microempreendedor',
    value: '159-Casa do Crédito S.A. Sociedade de Crédito ao Microempreendedor',
  },
  {
    label: '163-Commerzbank Brasil S.A. - Banco Múltiplo',
    value: '163-Commerzbank Brasil S.A. - Banco Múltiplo',
  },
  {
    label: '169-Banco Olé Bonsucesso Consignado S.A.',
    value: '169-Banco Olé Bonsucesso Consignado S.A.',
  },
  {
    label: '172-Albatross Corretora de Câmbio e Valores S.A',
    value: '172-Albatross Corretora de Câmbio e Valores S.A',
  },
  {
    label: '173-BRL Trust Distribuidora de Títulos e Valores Mobiliários S.A.',
    value: '173-BRL Trust Distribuidora de Títulos e Valores Mobiliários S.A.',
  },
  {
    label:
      '174-Pernambucanas Financiadora S.A. Crédito, Financiamento e Investimento',
    value:
      '174-Pernambucanas Financiadora S.A. Crédito, Financiamento e Investimento',
  },
  {
    label: '177-Guide Investimentos S.A. Corretora de Valores',
    value: '177-Guide Investimentos S.A. Corretora de Valores',
  },
  {
    label:
      '180-CM Capital Markets Corretora de Câmbio, Títulos e Valores Mobiliários Ltda.',
    value:
      '180-CM Capital Markets Corretora de Câmbio, Títulos e Valores Mobiliários Ltda.',
  },
  {
    label:
      '182-Dacasa Financeira S/A - Sociedade de Crédito, Financiamento e Investimento',
    value:
      '182-Dacasa Financeira S/A - Sociedade de Crédito, Financiamento e Investimento',
  },
  {
    label: '183-Socred S.A. - Sociedade de Crédito ao Microempreendedor',
    value: '183-Socred S.A. - Sociedade de Crédito ao Microempreendedor',
  },
  {
    label: '184-Banco Itaú BBA S.A.',
    value: '184-Banco Itaú BBA S.A.',
  },
  {
    label: '188-Ativa Investimentos S.A. Corretora de Títulos Câmbio e Valores',
    value: '188-Ativa Investimentos S.A. Corretora de Títulos Câmbio e Valores',
  },
  {
    label: '189-HS Financeira S/A Crédito, Financiamento e Investimentos',
    value: '189-HS Financeira S/A Crédito, Financiamento e Investimentos',
  },
  {
    label:
      '190-Cooperativa de Economia e Crédito Mútuo dos Servidores Públicos Estaduais do Rio',
    value:
      '190-Cooperativa de Economia e Crédito Mútuo dos Servidores Públicos Estaduais do Rio',
  },
  {
    label: '191-Nova Futura Corretora de Títulos e Valores Mobiliários Ltda.',
    value: '191-Nova Futura Corretora de Títulos e Valores Mobiliários Ltda.',
  },
  {
    label: '194-Parmetal Distribuidora de Títulos e Valores Mobiliários Ltda.',
    value: '194-Parmetal Distribuidora de Títulos e Valores Mobiliários Ltda.',
  },
  {
    label: '196-Fair Corretora de Câmbio S.A.',
    value: '196-Fair Corretora de Câmbio S.A.',
  },
  {
    label: '197-Stone Pagamentos S.A.',
    value: '197-Stone Pagamentos S.A.',
  },
  {
    label: '204-Banco Bradesco Cartões S.A.',
    value: '204-Banco Bradesco Cartões S.A.',
  },
  {
    label: '208-Banco BTG Pactual S.A.',
    value: '208-Banco BTG Pactual S.A.',
  },
  {
    label: '212-Banco Original S.A.',
    value: '212-Banco Original S.A.',
  },
  {
    label: '213-Banco Arbi S.A.',
    value: '213-Banco Arbi S.A.',
  },
  {
    label: '217-Banco John Deere S.A.',
    value: '217-Banco John Deere S.A.',
  },
  {
    label: '218-Banco BS2 S.A.',
    value: '218-Banco BS2 S.A.',
  },
  {
    label: '222-Banco Credit Agrícole Brasil S.A.',
    value: '222-Banco Credit Agrícole Brasil S.A.',
  },
  {
    label: '224-Banco Fibra S.A.',
    value: '224-Banco Fibra S.A.',
  },
  {
    label: '233-Banco Cifra S.A.',
    value: '233-Banco Cifra S.A.',
  },
  {
    label: '237-Banco Bradesco S.A.',
    value: '237-Banco Bradesco S.A.',
  },
  {
    label: '241-Banco Clássico S.A.',
    value: '241-Banco Clássico S.A.',
  },
  {
    label: '243-Banco Máxima S.A.',
    value: '243-Banco Máxima S.A.',
  },
  {
    label: '246-Banco ABC Brasil S.A.',
    value: '246-Banco ABC Brasil S.A.',
  },
  {
    label: '249-Banco Investcred Unibanco S.A.',
    value: '249-Banco Investcred Unibanco S.A.',
  },
  {
    label: '250-BCV - Banco de Crédito e Varejo S/A',
    value: '250-BCV - Banco de Crédito e Varejo S/A',
  },
  {
    label: '253-Bexs Corretora de Câmbio S/A',
    value: '253-Bexs Corretora de Câmbio S/A',
  },
  {
    label: '254-Parana Banco S. A.',
    value: '254-Parana Banco S. A.',
  },
  {
    label: '260-Nu Pagamentos S.A.',
    value: '260-Nu Pagamentos S.A.',
  },
  {
    label: '265-Banco Fator S.A.',
    value: '265-Banco Fator S.A.',
  },
  {
    label: '266-Banco Cédula S.A.',
    value: '266-Banco Cédula S.A.',
  },
  {
    label: '268-Barigui Companhia Hipotecária',
    value: '268-Barigui Companhia Hipotecária',
  },
  {
    label: '269-HSBC Brasil S.A. Banco de Investimento',
    value: '269-HSBC Brasil S.A. Banco de Investimento',
  },
  {
    label: '271-IB Corretora de Câmbio, Títulos e Valores Mobiliários Ltda.',
    value: '271-IB Corretora de Câmbio, Títulos e Valores Mobiliários Ltda.',
  },
  {
    label: '300-Banco de la Nacion Argentina',
    value: '300-Banco de la Nacion Argentina',
  },
  {
    label: '318-Banco BMG S.A.',
    value: '318-Banco BMG S.A.',
  },
  {
    label: '320-China Construction Bank (Brasil) Banco Múltiplo S/A',
    value: '320-China Construction Bank (Brasil) Banco Múltiplo S/A',
  },
  {
    label: '341-Itaú Unibanco  S.A.',
    value: '341-Itaú Unibanco  S.A.',
  },
  {
    label: '366-Banco Société Générale Brasil S.A.',
    value: '366-Banco Société Générale Brasil S.A.',
  },
  {
    label: '370-Banco Mizuho do Brasil S.A.',
    value: '370-Banco Mizuho do Brasil S.A.',
  },
  {
    label: '376-Banco J. P. Morgan S. A.',
    value: '376-Banco J. P. Morgan S. A.',
  },
  {
    label: '389-Banco Mercantil do Brasil S.A.',
    value: '389-Banco Mercantil do Brasil S.A.',
  },
  {
    label: '394-Banco Bradesco Financiamentos S.A.',
    value: '394-Banco Bradesco Financiamentos S.A.',
  },
  {
    label: '399-Kirton Bank S.A. - Banco Múltiplo',
    value: '399-Kirton Bank S.A. - Banco Múltiplo',
  },
  {
    label: '412-Banco Capital S. A.',
    value: '412-Banco Capital S. A.',
  },
  {
    label: '422-Banco Safra S.A.',
    value: '422-Banco Safra S.A.',
  },
  {
    label: '456-Banco MUFG Brasil S.A.',
    value: '456-Banco MUFG Brasil S.A.',
  },
  {
    label: '464-Banco Sumitomo Mitsui Brasileiro S.A.',
    value: '464-Banco Sumitomo Mitsui Brasileiro S.A.',
  },
  {
    label: '473-Banco Caixa Geral - Brasil S.A.',
    value: '473-Banco Caixa Geral - Brasil S.A.',
  },
  {
    label: '477-Citibank N.A.',
    value: '477-Citibank N.A.',
  },
  {
    label: '479-Banco ItauBank S.A.',
    value: '479-Banco ItauBank S.A.',
  },
  {
    label: '487-Deutsche Bank S.A. - Banco Alemão',
    value: '487-Deutsche Bank S.A. - Banco Alemão',
  },
  {
    label: '488-JPMorgan Chase Bank, National Association',
    value: '488-JPMorgan Chase Bank, National Association',
  },
  {
    label: '492-ING Bank N.V.',
    value: '492-ING Bank N.V.',
  },
  {
    label: '494-Banco de La Republica Oriental del Uruguay',
    value: '494-Banco de La Republica Oriental del Uruguay',
  },
  {
    label: '495-Banco de La Provincia de Buenos Aires',
    value: '495-Banco de La Provincia de Buenos Aires',
  },
  {
    label: '505-Banco Credit Suisse (Brasil) S.A.',
    value: '505-Banco Credit Suisse (Brasil) S.A.',
  },
  {
    label: '545-Senso Corretora de Câmbio e Valores Mobiliários S.A.',
    value: '545-Senso Corretora de Câmbio e Valores Mobiliários S.A.',
  },
  {
    label: '600-Banco Luso Brasileiro S.A.',
    value: '600-Banco Luso Brasileiro S.A.',
  },
  {
    label: '604-Banco Industrial do Brasil S.A.',
    value: '604-Banco Industrial do Brasil S.A.',
  },
  {
    label: '610-Banco VR S.A.',
    value: '610-Banco VR S.A.',
  },
  {
    label: '611-Banco Paulista S.A.',
    value: '611-Banco Paulista S.A.',
  },
  {
    label: '612-Banco Guanabara S.A.',
    value: '612-Banco Guanabara S.A.',
  },
  {
    label: '613-Omni Banco S.A.',
    value: '613-Omni Banco S.A.',
  },
  {
    label: '623-Banco Pan S.A.',
    value: '623-Banco Pan S.A.',
  },
  {
    label: '626-Banco Ficsa S. A.',
    value: '626-Banco Ficsa S. A.',
  },
  {
    label: '630-Banco Intercap S.A.',
    value: '630-Banco Intercap S.A.',
  },
  {
    label: '633-Banco Rendimento S.A.',
    value: '633-Banco Rendimento S.A.',
  },
  {
    label: '634-Banco Triângulo S.A.',
    value: '634-Banco Triângulo S.A.',
  },
  {
    label: '637-Banco Sofisa S. A.',
    value: '637-Banco Sofisa S. A.',
  },
  {
    label: '641-Banco Alvorada S.A.',
    value: '641-Banco Alvorada S.A.',
  },
  {
    label: '643-Banco Pine S.A.',
    value: '643-Banco Pine S.A.',
  },
  {
    label: '652-Itaú Unibanco Holding S.A.',
    value: '652-Itaú Unibanco Holding S.A.',
  },
  {
    label: '653-Banco Indusval S. A.',
    value: '653-Banco Indusval S. A.',
  },
  {
    label: '654-Banco A. J. Renner S.A.',
    value: '654-Banco A. J. Renner S.A.',
  },
  {
    label: '655-Banco Votorantim S.A.',
    value: '655-Banco Votorantim S.A.',
  },
  {
    label: '707-Banco Daycoval S.A.',
    value: '707-Banco Daycoval S.A.',
  },
  {
    label: '712-Banco Ourinvest S.A.',
    value: '712-Banco Ourinvest S.A.',
  },
  {
    label: '719-Banif - Bco Internacional do Funchal (Brasil) S.A.',
    value: '719-Banif - Bco Internacional do Funchal (Brasil) S.A.',
  },
  {
    label: '735-Banco Neon S.A.',
    value: '735-Banco Neon S.A.',
  },
  {
    label: '739-Banco Cetelem S.A.',
    value: '739-Banco Cetelem S.A.',
  },
  {
    label: '741-Banco Ribeirão Preto S.A.',
    value: '741-Banco Ribeirão Preto S.A.',
  },
  {
    label: '743-Banco Semear S.A.',
    value: '743-Banco Semear S.A.',
  },
  {
    label: '745-Banco Citibank S.A.',
    value: '745-Banco Citibank S.A.',
  },
  {
    label: '746-Banco Modal S.A.',
    value: '746-Banco Modal S.A.',
  },
  {
    label: '747-Banco Rabobank International Brasil S.A.',
    value: '747-Banco Rabobank International Brasil S.A.',
  },
  {
    label: '748-Banco Cooperativo Sicredi S. A.',
    value: '748-Banco Cooperativo Sicredi S. A.',
  },
  {
    label: '751-Scotiabank Brasil S.A. Banco Múltiplo',
    value: '751-Scotiabank Brasil S.A. Banco Múltiplo',
  },
  {
    label: '752-Banco BNP Paribas Brasil S.A.',
    value: '752-Banco BNP Paribas Brasil S.A.',
  },
  {
    label: '753-Novo Banco Continental S.A. - Banco Múltiplo',
    value: '753-Novo Banco Continental S.A. - Banco Múltiplo',
  },
  {
    label: '754-Banco Sistema S.A.',
    value: '754-Banco Sistema S.A.',
  },
  {
    label: '755-Bank of America Merrill Lynch Banco Múltiplo S.A.',
    value: '755-Bank of America Merrill Lynch Banco Múltiplo S.A.',
  },
  {
    label: '756-Banco Cooperativo do Brasil S/A - Bancoob',
    value: '756-Banco Cooperativo do Brasil S/A - Bancoob',
  },
  {
    label: '757-Banco Keb Hana do Brasil S. A.',
    value: '757-Banco Keb Hana do Brasil S. A.',
  },
];
